















import { defineComponent, ref } from "@vue/composition-api";
import CloseDialog from "@c/atoms/app/CloseDialog.vue";

export default defineComponent({
  name: "Help",

  props: {
    text: String
  },

  components: {
    CloseDialog
  },

  setup() {
    var dialog = ref(false);

    return {
      dialog
    };
  }
});
